<wbo-edit-page #editPage [formGroup]="editPage.formGroup" [title]="model.data.name" (addingAnother)="addingAnother($event)">

    <fui-formation-group-template
        *formationGroup="{title: 'wbo.access-role.edit.formation.details', formControlNames: ''}">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="name"
                                               [(ngModel)]="model.data.name"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="details"
                                               [(ngModel)]="model.data.details"></wbo-textarea-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>

    </fui-formation-group-template>

    <ng-container *ngIf="localisableContext">
        <ng-container *ngFor="let p of this.privileges">
            <fui-formation-group-template
                *formationGroup="{title: 'privileges.' + p.name + '.grouptype'}">
                <fui-rows>
                    <fui-row *ngFor="let section of p.sections">
                        <fui-columns>
                            <fui-column [label]="'privileges.' + p.name + '.group.' + section.name">
                                <wbo-privilege-selection [privileges]="section.privileges"
                                                         [authorisations]="model.data.authorisations"
                                                         [groupName]="p.name"></wbo-privilege-selection>
                            </fui-column>
                        </fui-columns>
                    </fui-row>
                </fui-rows>
            </fui-formation-group-template>

        </ng-container>
    </ng-container>

    <ng-container *ngIf="localisableContext">
        <fui-formation-group-template *formationGroup="{title: 'wbo.localisation.formation'}">
            <wbo-edit-localisation (selectionChanged)="selectionChanged()"
                                   [localisable]="localisableContext"></wbo-edit-localisation>
        </fui-formation-group-template>
    </ng-container>

</wbo-edit-page>
